"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var WarningCircleIcon16Solid_1 = require("./icons/WarningCircleIcon/WarningCircleIcon16Solid");
Object.defineProperty(exports, "WarningCircleIcon16Solid", { enumerable: true, get: function () { return WarningCircleIcon16Solid_1.WarningCircleIcon16Solid; } });
